import { StyleSheet } from "react-native";
import { appColors } from "../../appTheme";

export const sellScreenProductsStyle = StyleSheet.create({
    categoryView: {
        borderRadius: 5,
        backgroundColor: appColors?.light
    },
    categoryInnerView: {
        margin: 10,
        padding: 10,
        paddingHorizontal: 15,
        borderRadius: 30,
        flexDirection: "row",
        alignItems: "center"
    },
    topViewStyle: {
        flexDirection: "row",
        // alignItems: "center",
    },
    popoverAbsoluteView: {
        position: "absolute",
        width: "100%",
        height: "100%"
    },
    popoverInnerView: {
        alignSelf: "center",
        backgroundColor: appColors?.light,
        borderRadius: 10,
        padding: 5,
        elevation: 6,
        margin: 5
    },
    locationModalAbsoluteView: {
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "transparent"
    },
    categoryListStyle: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        flexWrap: "wrap"
    },
    subCategoryPressable: {
        padding: 10,
        paddingHorizontal: 15
    },
    subCategoryInnerView: {
        marginStart: 25,
        flexWrap: "wrap",
    },
    varientCountView: {
        backgroundColor: appColors?.badgeColor,
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        padding: 3,
        paddingHorizontal: 7
    },
    priceRangeOuterView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    productAvailableView: {
        paddingVertical: 5,
        paddingHorizontal: 10,
        borderRadius: 5,
        marginTop: 7,
        alignItems: "center",
        alignSelf: "center",
        marginBottom: 5
    }
})